import z from "zod";

import { machineWorkstationSchema } from "./machine-workstation";

export const workstationChangedSchema = z.object({
	tenantId: z.string(),
	machineId: z.string(),
	workstations: z.array(machineWorkstationSchema),
});

export type WorkstationChanged = z.infer<typeof workstationChangedSchema>;
